import React, { useMemo } from 'react';
import { find, get, identity } from 'lodash';

import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { IncomeEntityIndex, Owner, StoreApplicant } from '@funnels/types';
import { getApplicantOptions, transformApplicantsToEqualOwners } from '@funnels/utils';

import { DropdownField, StringsDisplay } from '../../Fields';
import { EditableViewProps, StringsReadOnlyViewProps } from '../types';

interface IncomeOwnershipEditableViewProps extends EditableViewProps, IncomeEntityIndex {
  disableFailMessage?: boolean;
}

const format = (v?: Owner[]) => {
  if (Array.isArray(v)) {
    const _v = v.map((o: Owner) => o.percent && (o.applicantClientId || o.applicantId || ''));
    return identity(_v);
  }
  return identity(v); // prevent any undefined
};

export const IncomeOwnershipEditableView = (props: IncomeOwnershipEditableViewProps) => {
  const { incomeIndex } = props;
  const [formValues, setFormValue] = useFormValues();
  const applicants = get(formValues, FIELD_PATHS.APPLICANTS(), []) as StoreApplicant[];
  const applicantOptions = useMemo(
    () => getApplicantOptions(applicants, false, undefined, undefined, false),
    [applicants]
  );

  const onChange = (ownerIds: string[]) => {
    const ownerApplicants = ownerIds.map((o) => find(applicants, { id: o })) as StoreApplicant[];
    const owners = transformApplicantsToEqualOwners(ownerApplicants);

    setFormValue(FIELD_PATHS.INCOME_OWNERS(incomeIndex), owners);
    return true; //skip the delayed assignment
  };

  return (
    <DropdownField
      format={format}
      name={FIELD_PATHS.INCOME_OWNERS(incomeIndex)}
      onChange={onChange}
      options={applicantOptions}
      validationFailMessage={'Please add an applicant.'}
      className={PII_FIELD_MASKING_CLASS}
      shouldAnchorList
    />
  );
};

export const IncomeOwnershipReadOnlyView = (props: StringsReadOnlyViewProps) => {
  const { value, ...rest } = props;

  return <StringsDisplay {...rest} values={value} className={PII_FIELD_MASKING_CLASS} />;
};
